import React, { FC, ReactNode } from 'react';

import { fontFamilies } from 'components/UI/Font';

/* eslint-disable react/no-danger */

const splitLinesIntoListItems = (text: string): ReactNode => {
  const unifiedNewLines = text.replace(/(?:\r\n|\r|\n|< *br *\/?>)/g, '\n');
  const withoutDuplicateNewLines = unifiedNewLines.replace(/\n{2,}/g, '\n').trim();
  const values = withoutDuplicateNewLines.split('\n');

  return values.map(str => (str ? <li>{str}</li> : null));
};

export const StyleList: FC<{
  sizeFit: string;
  storeColor: string;
}> = ({ storeColor, sizeFit }) => {
  return (
    <>
      <p className="style-title">Style</p>
      <ul className="style-list">
        {storeColor && <li dangerouslySetInnerHTML={{ __html: storeColor }} />}

        {splitLinesIntoListItems(sizeFit)}
      </ul>

      <style jsx>{`
        .style-title {
          font-family: ${fontFamilies.bold};
        }

        .style-list {
          list-style-type: disc;
          margin-bottom: 0;
        }
        :global(.style-list li) {
          line-height: 20px;
          padding-left: 10px;
        }
      `}</style>
    </>
  );
};
